<template>
    <div>
        <div>
            <span class="form-label">Construction</span>
        </div>
        <div class="construction-list">
            <el-table :data="buildingList" class="w-100">
                <el-table-column class-name="action-column" v-if="!readOnly" width="50">
                    <template slot-scope="scope">
                        <div class="action-buttons">
                            <el-button
                                icon="el-icon-edit"
                                size="small"
                                circle
                                @click="editClick(scope.row)"
                            ></el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('Building/Structure Name')">
                </el-table-column>
                <el-table-column
                    :label="$t('Occupancy')"
                    prop="occ"
                    align="center"
                ></el-table-column>
                <el-table-column
                    :label="$t('Year Built')"
                    prop="yr"
                    align="center"
                ></el-table-column>
                <el-table-column
                    :label="$t('Roof Construction')"
                    prop="rc"
                    align="center"
                ></el-table-column>
                <el-table-column
                    :label="$t('Walls Construction')"
                    prop="wc"
                    align="center"
                ></el-table-column>
                <el-table-column
                    :label="$t('Composite Panels')"
                    prop="cp"
                    align="center"
                ></el-table-column>
                <el-table-column
                    :label="$t('Overall Classification Summary')"
                    prop="ocs"
                    align="center"
                ></el-table-column>
                <el-table-column
                    :label="$t('Sprinklers Adequate %')"
                    prop="sa"
                    align="center"
                ></el-table-column>
                <el-table-column
                    :label="$t('Sprinklers Deficiency %')"
                    prop="sd"
                    align="center"
                ></el-table-column>
                <el-table-column :label="$t('Storeys')" prop="st" align="center"></el-table-column>
                <el-table-column
                    :label="$t('Estimated Building Height (m2)')"
                    prop="eh"
                    align="center"
                ></el-table-column>
                <el-table-column
                    :label="$t('Ground Floor Area (m2)')"
                    prop="gf"
                    align="center"
                ></el-table-column>
                <el-table-column
                    :label="$t('Total Building Area (m2)')"
                    prop="ta"
                    align="center"
                ></el-table-column>

                <el-table-column :label="$t('Estimated PD %')" align="center">
                    <template slot-scope="scope">
                        <div>{{ getEstimatedPd(scope.row) }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog
            v-if="buildingModal"
            :title="buildingItem ? buildingItem.name : null"
            :visible.sync="buildingModal"
            append-to-body
            :close-on-click-modal="false"
        >
            <el-form label-width="120px" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="$t('Occupancy')">
                            <el-select
                                v-model="buildingItem.occ"
                                :placeholder="$t('Please select occupancy')"
                                filterable
                                class="w-100"
                                size="small"
                            >
                                <el-option
                                    v-for="item in occupancyTypes"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                    <span>{{ item }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('Year Built')">
                            <el-select
                                v-model="buildingItem.yr"
                                :placeholder="$t('Please select year')"
                                filterable
                                class="w-100"
                                size="small"
                            >
                                <el-option
                                    v-for="item in yearBuiltTypes"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                    <span>{{ item }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('Roof Construction')">
                            <el-select
                                v-model="buildingItem.rc"
                                :placeholder="$t('Please select type')"
                                filterable
                                class="w-100"
                                size="small"
                            >
                                <el-option
                                    v-for="item in rcTypes"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                    <span>{{ item }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="$t('Walls Construction')">
                            <el-select
                                v-model="buildingItem.wc"
                                :placeholder="$t('Please select type')"
                                filterable
                                class="w-100"
                                size="small"
                            >
                                <el-option
                                    v-for="item in rcTypes"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                    <span>{{ item }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('Composite Panels')">
                            <el-select
                                v-model="buildingItem.cp"
                                :placeholder="$t('Please select panel')"
                                filterable
                                class="w-100"
                                size="small"
                            >
                                <el-option
                                    v-for="item in cpTypes"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                    <span>{{ item }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('Over Classification Summary')">
                            <el-select
                                v-model="buildingItem.ocs"
                                :placeholder="$t('Please select panel')"
                                filterable
                                class="w-100"
                                size="small"
                            >
                                <el-option
                                    v-for="item in rcTypes"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                    <span>{{ item }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="$t('Sprinklers Adequate %')">
                            <el-input
                                :placeholder="$t('Percentage')"
                                v-model.number="buildingItem.sa"
                                size="small"
                                class="w-25 text-align-left number-field"
                                type="number"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('Sprinklers Deficiency %')">
                            <el-input
                                :placeholder="$t('Percentage')"
                                v-model="buildingItem.sd"
                                size="small"
                                class="w-25 text-align-left number-field"
                                type="number"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('Storeys')">
                            <el-input
                                :placeholder="$t('Storeys')"
                                v-model="buildingItem.st"
                                size="small"
                                class="w-25 text-align-left number-field"
                                type="number"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="$t('Estimated Building Height (m2)')">
                            <el-input
                                :placeholder="$t('Height')"
                                v-model="buildingItem.eh"
                                size="small"
                                class="w-25 text-align-left number-field"
                                type="number"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('Ground Floor Area (m2')">
                            <el-input
                                :placeholder="$t('Area')"
                                v-model="buildingItem.gf"
                                size="small"
                                class="w-25 text-align-left number-field"
                                type="number"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('Total Building Area (m2)')">
                            <el-input
                                :placeholder="$t('Area')"
                                v-model="buildingItem.ta"
                                size="small"
                                class="w-25 text-align-left number-field"
                                type="number"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button class="el-button--primary" @click="save">{{ $t('Complete') }}</el-button>
                <el-button @click="cancel">{{ $t('Cancel') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import FormQuestion from '@/data/FormQuestion';
import Collection from '@/lib/data/Collection';
import BuildingRSA from '@/data/BuildingRSA';

export default {
    props: {
        question: {
            type: FormQuestion,
            default: new FormQuestion(),
        },
        value: {
            type: Array,
            default: new Collection({
                model: BuildingRSA,
            }),
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            buildingItem: null,
            buildingModal: false,
            buildingList: null,
            occupancyTypes: [
                'Healthcare',
                'Office',
                'Production',
                'Retail',
                'Retail & Leisure',
                'Services',
                'Utilities',
                'Warehouse]',
            ],
            yearBuiltTypes: [
                '1720-1839',
                '1840-1919',
                '1920-1945',
                '1946-1979',
                '1980-1999',
                '2000-To date',
            ],
            rcTypes: [
                'Fire Resistant',
                'Heavy Non-Combustible',
                'Light Non-Combustible',
                'Partly Combustible',
                'Combustible',
                'Highly Combustible',
            ],
            cpTypes: [
                'Cellular Plastic - Approved',
                'Cellular Plastic - Non Approved',
                'Other Non-Combustible',
                'None',
                'Unknown AssumeCombustible',
            ],
        };
    },
    created() {
        this.buildingList = this.value;
    },
    methods: {
        editClick(data) {
            this.buildingItem = data;
            this.buildingModal = true;
        },
        deleteClick(index) {
            this.buildingList.splice(index, 1);
        },
        save() {
            this.buildingModal = false;
            this.buildingItem.commit();
            this.buildingList.add(this.buildingItem);
            // this.$emit('input', this.buildingList)
        },
        cancel() {
            this.buildingModal = false;
            this.buildingItem.reject();
        },
        getEstimatedPd(data) {
            let total = 0;
            this.buildingList
                .map((item) => item.total)
                .forEach((value) => {
                    total += parseFloat(value);
                });

            return ((parseFloat(data.total) * 100) / total).toFixed(2);
        },
    },
};
</script>
<style lang="scss">
.construction-list {
    .el-table th.el-table__cell {
        background-color: #f5f7fa !important;
    }

    .action-column {
        .cell {
            overflow: visible;
        }

        .action-buttons {
            display: flex;
            align-items: center;
            justify-content: space-evenly;

            .el-button {
                margin: 0px;
            }

            .up-down-action {
                padding: 3px;
            }
        }
    }
}

.number-field {
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type='number'] {
        -moz-appearance: textfield;
    }
}
</style>
